import { faImages } from "@fortawesome/free-regular-svg-icons";
import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";

const image = [
  "https://images.pexels.com/photos/719597/pexels-photo-719597.jpeg?cs=srgb&dl=pexels-iconcom-719597.jpg&fm=jpg",
  "https://images.pexels.com/photos/2889381/pexels-photo-2889381.jpeg?cs=srgb&dl=pexels-thomas-degrange-2889381.jpg&fm=jpg",
  "https://images.pexels.com/photos/358759/pexels-photo-358759.jpeg?cs=srgb&dl=pexels-photo-collections-358759.jpg&fm=jpg",
  "https://images.pexels.com/photos/4630001/pexels-photo-4630001.jpeg?cs=srgb&dl=pexels-nadezhda-moryak-4630001.jpg&fm=jpg",
];
const OffersOfWeekComponent = () => {
  //   const [images, setImages] = useState(image);
  //   const [index, setIndex] = useState(0);
  //   useEffect(() => {
  //     const intervalId = setInterval(() => {
  //       if (index === images.length - 1) {
  //         setIndex(0);
  //       } else {
  //         setIndex(index + 1);
  //       }
  //     }, 3000);

  //     return () => clearInterval(intervalId);
  //   }, [index]);

  //   const imageIndex = () => {
  //     console.log("here", index < image.length, index, image.length);
  //     let x = index + 1;
  //     if (index < images.length) {
  //       console.log("x ==> ", x);
  //       setIndex(x);
  //     } else {
  //       setIndex(0);
  //     }

  //     return index;
  //   };

  return (
    <>
      <h5>Offers of the Week</h5>

      {/* <img width="400" height="300" src={images[index]}></img> */}
      <Carousel fade>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="https://images.pexels.com/photos/1174732/pexels-photo-1174732.jpeg?cs=srgb&dl=pexels-vincent-gerbouin-1174732.jpg&fm=jpg"
            alt="First slide"
            height="300"
          />
          <Carousel.Caption>
            <h3>First slide label</h3>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="https://images.pexels.com/photos/3355732/pexels-photo-3355732.jpeg?cs=srgb&dl=pexels-quang-nguyen-vinh-3355732.jpg&fm=jpg"
            alt="Second slide"
            height="300"
          />

          <Carousel.Caption>
            <h3>Second slide label</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="https://images.pexels.com/photos/1710795/pexels-photo-1710795.jpeg?cs=srgb&dl=pexels-chedi-tanabene-1710795.jpg&fm=jpg"
            alt="Third slide"
            height="300"
          />

          <Carousel.Caption>
            <h3>Third slide label</h3>
            <p>
              Praesent commodo cursus magna, vel scelerisque nisl consectetur.
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </>
  );
};

export default OffersOfWeekComponent;
